import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';

import { LoadingScreen } from '@/components/LoadingScreen';

import { useAuth } from './useAuth';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const location = useLocation();
  const { loading, user } = useAuth();

  if (loading) {
    return <LoadingScreen message="Checking authentication..." />;
  }

  if (!user) {
    const returnTo = `${location.pathname}${location.search}${location.hash}`;

    return (
      <Navigate
        replace
        to={`/login?returnTo=${encodeURIComponent(returnTo)}`}
      />
    );
  }

  return <>{children}</>;
}
